import GenericFormModalContainer from "../../../../components/TailwindControls/Modals/FormModal/GenericFormModalContainer";
import Lottie from "lottie-react";
import Link from "next/link";
import React, { useCallback, useEffect, useState } from "react";
import Button from "../../../../components/TailwindControls/Form/Button/Button";
import { useRouter } from "next/router";
import { Config } from "../../../../shared/constants";
import { cookieUserStore } from "../../../../stores/Cookies/CookieUserStore";
import { useMutation } from "@apollo/client";
import { AUDIT_LOGGING } from "../../../../graphql/mutations/auditlogging";
import { getAuditLogData } from "../../../../shared/getAuditLogData";
import { instanceAddFinishedAnimation } from "../../../../shared/themeHelper/themeHelperfunc";
import { useBaseDomain } from "../../../../shared/context/RuntimeConfigContext";
import { navigateToUrl } from "../../../../shared/navigateToUrl";

export function InstanceAddFinished({
  href,
  instanceAdmins,
  instanceId,
  onButtonClose,
}: {
  href: string;
  instanceAdmins: string[];
  instanceId: string;
  onButtonClose: () => void;
}) {
  const router = useRouter();
  const [geoLocation, setGeoLocation] = useState<{
    latitude?: string;
    longitude?: string;
  }>({});
  const baseDomain = useBaseDomain();
  const completeOptions = {
    loop: false,
    autoplay: true,
    animationData: instanceAddFinishedAnimation(baseDomain),
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const callbackRef = useCallback((inputElement: HTMLAnchorElement) => {
    if (inputElement) {
      inputElement.focus();
    }
  }, []);

  const [auditLogLoginLogout] = useMutation(AUDIT_LOGGING, {
    fetchPolicy: "no-cache",
    context: { headers: { vrynopath: "crm" } },
  });
  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setGeoLocation({
            latitude: position.coords.latitude.toString(),
            longitude: position.coords.longitude.toString(),
          });
        },
        (error) => {
          console.warn("Geolocation error:", error);
        },
        { timeout: 5000, maximumAge: 0 }
      );
    }
  }, []);

  const userEmail = cookieUserStore.getUserDetails()?.email;
  const isAdmin = userEmail && instanceAdmins.includes(userEmail);
  return (
    <GenericFormModalContainer
      topIconType="None"
      limitWidth={true}
      allowScrollbar={false}
    >
      <div className="w-full h-full flex flex-col items-center">
        <span className="font-bold text-xl text-vryno-label-gray">
          And we&#39;re done!
        </span>
        <Lottie
          animationData={completeOptions.animationData}
          loop={completeOptions.loop}
          autoplay={completeOptions.autoplay}
          rendererSettings={completeOptions.rendererSettings}
          style={{ height: "180px", width: "180px" }}
        />
        <div
          className={`w-full ${isAdmin ? "grid grid-cols-2" : "flex"} gap-x-6`}
        >
          <Button
            id="close-modal"
            kind="back"
            buttonType="thin"
            onClick={() => {
              if (router.asPath.includes("/add")) {
                navigateToUrl(
                  router,
                  `${Config.publicRootUrl()}instances`,
                  true
                );
              } else {
                onButtonClose();
              }
            }}
            userEventName="add-instance-finished:close-click"
          >
            Close
          </Button>
          {isAdmin && (
            <Link href={href} legacyBehavior>
              <a
                id="lets-start-link"
                className="py-2 w-full text-sm flex flex-row items-center justify-center text-white rounded-md bg-vryno-theme-blue"
                ref={callbackRef}
                onClick={() => {
                  const auditData = getAuditLogData(
                    geoLocation?.latitude,
                    geoLocation?.longitude
                  );

                  auditLogLoginLogout({
                    variables: {
                      logType: "userLogin",
                      instanceId: instanceId,
                      userAgent: auditData.userAgent,
                      latitude: auditData.latitude,
                      longitude: auditData.longitude,
                    },
                  }).then((response) => {});
                }}
              >
                Let&#39;s Start
              </a>
            </Link>
          )}
        </div>
      </div>
    </GenericFormModalContainer>
  );
}
